module.exports = __webpack_public_path__ + "static/menu-ffaf803c88374d5c1f2e7656fcb044ef.png";